import React, { Component } from 'react'

const hasCloseEverythingIfNotActiveSelection = WrappedComponent => {
    class HasCloseEverythingIfNotActiveSelection extends Component {
        constructor(props) {
            super(props)

            this.state = {
                currentActiveSelection: ''
            }

            this.setIdForActiveSelection = this.setIdForActiveSelection.bind(this)
        }

        setIdForActiveSelection(selectionId) {
            this.setState({
                currentActiveSelection: selectionId
            })
        }

        render() {
            const injectedProps = {
                currentActiveSelection: this.state.currentActiveSelection,
                setIdForActiveSelection: this.setIdForActiveSelection
            }

            return <WrappedComponent
                {...this.props}
                {...injectedProps}
            />
        }
    }

    return HasCloseEverythingIfNotActiveSelection
}

export default hasCloseEverythingIfNotActiveSelection